module.exports = __webpack_public_path__ + "img/163.cellular.55efd68b.svg";